<main fxLayout="column">
  @if (loading) {
    <div fxLayoutAlign="center center" style="height: 250px">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  }

  @if (!loading) {
    <div fxLayoutAlign="center center" tabindex="0">
      @if (loginForm && loginConfig) {
        <div fxLayout="column" class="login-card">
          <!-- Login Form -->
          <form [formGroup]="loginForm">
            <!-- Login Instructions  -->
            <div fxLayout="row" style="margin-bottom: 1.75rem">
              <div [innerHTML]="loginConfig.loginInstructionalText"></div>
            </div>
            <!-- Library List Autocomplete -->
            @if (loginConfig.showLibraryLookupBox) {
              <div fxLayout="row">
                @if (libraries.length) {
                  <mat-form-field fxFlex="100">
                    <mat-label>Select Your Library</mat-label>
                    <input
                      #libraryInput
                      matInput
                      type="text"
                      placeholder="Select Your Library"
                      [formControl]="librariesControl"
                      [matAutocomplete]="auto"
                      (focus)="onInputFocus()"
                    />
                    <button
                      mat-icon-button
                      matSuffix
                      type="button"
                      (click)="clearLibraryInput($event)"
                    >
                      <mat-icon>{{
                        librariesControl.value ? 'clear' : 'keyboard_arrow_down'
                      }}</mat-icon>
                    </button>
                    <mat-autocomplete
                      #auto="matAutocomplete"
                      autoActiveFirstOption
                      autoSelectActiveOption
                      (optionSelected)="onLibraryOptionSelected($event)"
                    >
                      @for (option of filteredLibraryOptions | async; track option) {
                        <mat-option [value]="option">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                    @if (librariesControl.invalid && !librariesControl.pristine) {
                      <mat-error>Please select a library</mat-error>
                    }
                  </mat-form-field>
                } @else {
                  <mat-form-field fxFlex="100">
                    <mat-label>Your Library</mat-label>
                    <input matInput type="text" readonly [formControl]="librariesControl" />
                  </mat-form-field>
                }
              </div>
            }
            <!-- User and Password -->
            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <input
                  #userName
                  agAutofocus
                  matInput
                  id="username"
                  type="text"
                  formControlName="user"
                  title="User Name"
                  autocomplete="on"
                  [placeholder]="loginConfig.userNameLabel"
                />
              </mat-form-field>
            </div>
            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <input
                  matInput
                  id="password"
                  type="password"
                  formControlName="password"
                  autocomplete="off"
                  title="Password"
                  [placeholder]="loginConfig.showPasswordPrompt ? loginConfig.passwordLabel : ''"
                />
              </mat-form-field>
            </div>
            <!-- Remember Me / Forget Your Password -->
            <div fxLayout="row" class="font-0-8" fxLayoutGap="10px" fxLayoutAlign="space-between">
              <mat-checkbox
                fxLayout="column"
                fxLayout.xs="row"
                fxflex="50"
                fxLayout.xs="100"
                formControlName="remember"
              >
                Remember Me?
              </mat-checkbox>
              @if (loginConfig.showForgotPasswordLink) {
                <button
                  fxLayout="column"
                  fxLayout.xs="row"
                  fxflex="50"
                  fxLayout.xs="100"
                  mat-button
                  type="button"
                  (agInteract)="forgotPassword()"
                >
                  Forgot Your Password
                </button>
              }
            </div>
            <!-- Self Registration -->
            @if (userData.allowSelfRegistration) {
              <div fxLayout="row" fxLayoutGap="10px" class="font-0-8">
                <button mat-button class="overflow-btn" type="button" (agInteract)="signUp()">
                  {{ userData.selfRegistrationLabel }}
                </button>
              </div>
            }
            <!-- Submit and Clear -->
            <div fxLayout="row" fxLayoutAlign="end">
              <button
                mat-button
                role="button"
                type="submit"
                aria-label="Submit"
                class="ag-mat-button-primary"
                [disabled]="loginForm.invalid"
                (click)="loginSubmit()"
              >
                @if (!btnLoading) {
                  <span style="width: 175px">Submit</span>
                }
                @if (btnLoading) {
                  <mat-icon>
                    <mat-spinner diameter="18"></mat-spinner>
                  </mat-icon>
                }
              </button>
              <button
                mat-button
                role="button"
                aria-label="Cancel"
                type="button"
                style="margin-left: 10px"
                (click)="goToHome()"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      }
    </div>
  }
</main>
